import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, setAnalyticsCollectionEnabled, setConsent } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: 'AIzaSyDSJzrhpzd15N4G1SZidIxp6wlCulWAbIA',
    authDomain: 'pill-reminder-59787.firebaseapp.com',
    projectId: 'pill-reminder-59787',
    storageBucket: 'pill-reminder-59787.firebasestorage.app',
    messagingSenderId: '766697590514',
    appId: '1:766697590514:web:8c685467f9767420050a6b',
    measurementId: 'G-JYYW0MX1P1',
};

let analyticsInstance = null;
let firebaseApp = null, allowed = false, generation = 0;
const consent = enabled => ({ analytics_storage: enabled ? 'granted' : 'denied',
    ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });

function updateAnalytics(runtime) {
    // Only a live native bridge response can start the WebView SDK. Cached runtime,
    // browser language, website visits, and QA/dev builds are not consent evidence.
    const next = Boolean(document.visibilityState === 'visible' && window.ReactNativeWebView && runtime?.isDev === false
        && runtime?.capabilities?.analyticsPrivacy === true && runtime?.analyticsPrivacy?.enabled === true);
    if (next === allowed) return;
    allowed = next;
    const token = ++generation;
    try {
        if (!next && analyticsInstance) setAnalyticsCollectionEnabled(analyticsInstance, false);
        setConsent(consent(next));
        if (next && analyticsInstance) setAnalyticsCollectionEnabled(analyticsInstance, true);
        if (next && !analyticsInstance) {
            Promise.resolve(isSupported()).then(supported => {
                if (!supported || !allowed || token !== generation) return;
                if (!firebaseApp) firebaseApp = initializeApp(firebaseConfig);
                analyticsInstance = getAnalytics(firebaseApp);
            }).catch(() => {});
        }
    } catch (_) { allowed = false; }
}
function onRuntime(event) {
    try {
        const message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (message?.type === 'APP_RUNTIME_INFO') updateAnalytics(message.data);
    } catch (_) {}
}
window.addEventListener('message', onRuntime);
document.addEventListener('message', onRuntime); // Android bridge
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') updateAnalytics(null);
});
window.addEventListener('pagehide', () => updateAnalytics(null));

function send(name, params) {
    if (!allowed || !analyticsInstance) return;
    try { Promise.resolve(logEvent(analyticsInstance, name, params)).catch(() => {}); } catch (_) {}
}

export function trackPageView(path) {
    send('page_view', { page_path: path });
}

export function trackEvent(name, params = {}) {
    send(name, params);
}
